module.exports = __webpack_public_path__ + "static/simplify-business-admin-90bbe31b0d39140a1ec08ec6f1ba7828.png";